import Matter from "matter-js";
import { Constants } from "../common/Constants";
import { addPipes } from "../generators/WorldGenerator";

const WorldManager = (entities: Entities, { dispatch }: { dispatch: any }) => {
  if (!entities || !entities.physics) return;

  let world = entities.physics.world;
  let flyer = entities.flyer.body;

  Object.keys(entities).forEach((key) => {
    if (key.startsWith("pipe") && entities.hasOwnProperty(key)) {
      let pipe = entities[key];
      Matter.Body.translate(pipe.body, { x: -Constants.MOVEMENT_SPEED, y: 0 });

      let pipeIndex = parseInt(key.replace("pipe", ""));
      if (pipeIndex % 2 === 0) {
        if (flyer.bounds.min.x >= pipe.body.bounds.max.x && !pipe.scored) {
          entities[key].scored = true;
          dispatch({ type: "score" });
        }

        if (pipe.body.position.x <= -Constants.PIPE_WIDTH) {
          delete entities["pipe" + (pipeIndex - 1)];
          delete entities["pipe" + pipeIndex];

          addPipes(
            pipe.body.position.x + Constants.PIPE_GAP * 2,
            world,
            entities
          );
        }
      }
    }
  });

  return entities;
};

export default WorldManager;
